import cloneDeep from 'lodash/fp/cloneDeep'
import { events as containerEvents } from './adviserProfileApprovalEditorContainerActions'
import { validateProfileForApproval } from '../../../../common/forms/validationFunctions'

import { START_EDITING_PENDING_APPROVAL_BLURB,
  STOP_EDITING_PENDING_APPROVAL_BLURB
  , SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME
  , SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME
  , SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME
  , SET_PENDING_APPROVAL_BLURB_ADVISER_TITLE
  , SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY
  , SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY_WEBSITE
  , SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS
  , SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS
  , SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB
  , SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE
  , SET_PENDING_APPROVAL_BLURB_ADVISER_CITY
  , SET_PENDING_APPROVAL_BLURB_ADVISER_DESCRIPTION
  , CANCEL_EDITING_PENDING_APPROVAL_BLURB } from '../AdviserProfile/PendingApprovalAdviserProfileBlurbEditor/pendingApprovalAdviserProfileBlurbEditorActions'

import { START_EDITING_PENDING_APPROVAL_LANGUAGES
  , STOP_EDITING_PENDING_APPROVAL_LANGUAGES
  , CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES
  , PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES
  , PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED
} from '../AdviserProfile/AdviserProfileLanguagePreferencesEditor/adviserProfileLanguagePreferencesEditorActions'

import {
   PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS
   , PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS
   , PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM
   , PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER
   , PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS
   , PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS
  } from '../AdviserProfile/AdviserProfileInvestmentMinimumsEditor/adviserProfileInvestmentMinimumsEditorActions'

import {
    PENDING_APPROVAL_START_EDITING_CLIENT_TYPES,
    PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES,
    PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES,
    PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES,
    PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED
  } from '../AdviserProfile/AdviserProfileClientTypesEditor/adviserProfileClientTypesEditorActions'

import {
    START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION,
    STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION,
    CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION,
    ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION,
    ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED
  } from '../AdviserProfile/AdviserProfileAreasOfSpecialisationEditor/adviserProfileAreasOfSpecialisationEditorActions'

import {
  PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED
} from '../AdviserProfile/PendingApprovalAdviserProfileConflictDeclarationsEditor/pendingApprovalAdviserProfileConflictDeclarationsEditorActions'

import {
  PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING
  , PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING
  , PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION
} from '../AdviserProfile/PendingApprovalAdviserProfileEducationEditor/pendingApprovalAdviserProfileEducationEditorActions.js'

import {
  PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE
} from '../AdviserProfile/PendingApprovalAdviserProfileWorkExperienceEditor/pendingApprovalAdviserProfileWorkExperienceEditorActions.js'

import {
  SUBMITTING_APPROVE_PROFILE,
  SUBMITTED_APPROVE_PROFILE
} from '../AdviserProfile/AdviserProfilePromoteToApproved/adviserProfilePromoteToApprovedActions'

import { events as picturesEvents } from '../AdviserProfile/AdviserProfilePicturesEditor/adviserProfilePicturesEditorActions'

import {
  PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER
  , PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS
  , PENDING_APPROVAL_STOP_EDITING_CONTACT_NUMBERS
  , PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS
  , PENDING_APPROVAL_SET_CONTACT_NUMBER
  , PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL
  , PENDING_APPROVAL_DELETE_CONTACT_NUMBER
  , PENDING_APPROVAL_DELETED_CONTACT_NUMBER
  , PENDING_APPROVAL_DELETING_CONTACT_NUMBER
  , PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER
  , PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS
  , PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
  , PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
  , PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
} from '../AdviserProfile/PendingApprovalAdviserProfileContactDetailsEditor/pendingApprovaladviserProfileContactDetailsEditorActions'

import adviserProfilePicturesEditorReducer from '../AdviserProfile/AdviserProfilePicturesEditor/adviserProfilePicturesEditorReducer'
import adviserProfileBlurbEditorReducer from '../AdviserProfile/PendingApprovalAdviserProfileBlurbEditor/pendingApprovalAdviserProfileBlurbEditorReducer'
import adviserProfileInvestmentMinimumsEditorReducer from '../AdviserProfile/AdviserProfileInvestmentMinimumsEditor/adviserProfileInvestmentMinimumsEditorReducer'
import adviserProfileLanguagePreferencesEditorReducer from '../AdviserProfile/AdviserProfileLanguagePreferencesEditor/adviserProfileLanguagePreferencesEditorReducer'
import adviserProfileClientTypesEditorReducer from '../AdviserProfile/AdviserProfileClientTypesEditor/adviserProfileClientTypesEditorReducer'
import adviserProfileAreasOfSpecialisationEditorReducer from '../AdviserProfile/AdviserProfileAreasOfSpecialisationEditor/adviserProfileAreasOfSpecialisationEditorReducer'
import adviserProfileConflictDeclarationsEditorReducer from '../AdviserProfile/PendingApprovalAdviserProfileConflictDeclarationsEditor/pendingApprovalAdviserProfileConflictDeclarationsEditorReducer'
import adviserProfileEducationEditorReducer from '../AdviserProfile/PendingApprovalAdviserProfileEducationEditor/pendingApprovalAdviserProfileEducationEditorReducer'
import adviserProfilePromoteToApprovedReducer from '../AdviserProfile/AdviserProfilePromoteToApproved/adviserProfilePromoteToApprovedReducer'
import adviserProfileContactDetailsEditorReducer from '../AdviserProfile/PendingApprovalAdviserProfileContactDetailsEditor/pendingApprovalAdviserProfileContactDetailsEditorReducer'
import adviserProfileWorkExperienceEditorReducer from '../AdviserProfile/PendingApprovalAdviserProfileWorkExperienceEditor/pendingApprovalAdviserProfileWorkExperienceEditorReducer'
import rejectProfileReducer from '../AdviserProfile/RejectPendingApprovalProfile/rejectPendingApprovalProfileReducer'
import { events as rejectPendingApprovalProfileEvents } from '../AdviserProfile/RejectPendingApprovalProfile/rejectPendingApprovalProfileActions'
import actionTypeInCollection from '../../../../common/ReducerHelperFunctions/actionInCollection'

const initialState = {
  blurb: adviserProfileBlurbEditorReducer(undefined, {}),
  investmentMinimums: adviserProfileInvestmentMinimumsEditorReducer(undefined, {}),
  languagePreferences: adviserProfileLanguagePreferencesEditorReducer(undefined, {}),
  conflictDeclarations: adviserProfileConflictDeclarationsEditorReducer(undefined, {}),
  clientTypes: adviserProfileClientTypesEditorReducer(undefined, {}),
  areasOfSpecialisation: adviserProfileAreasOfSpecialisationEditorReducer(undefined, {}),
  education: adviserProfileEducationEditorReducer(undefined, {}),
  contactDetails: adviserProfileContactDetailsEditorReducer(undefined, {}),
  profilePictures: adviserProfilePicturesEditorReducer(undefined, {}),
  promoteToApproved: adviserProfilePromoteToApprovedReducer(undefined, {}),
  experiences: adviserProfileWorkExperienceEditorReducer(undefined, {}),
  pendingApprovalProfile: {},
  publishedProfile: {},
  edited: false,
  loading: false,
  invalidArr: [],
  fetchingPublishedProfile: false,
  fetchingPendingApprovalProfile: false,
  foundDifferences: false,
  allContactNumberTypes: [],
  rejectProfile: rejectProfileReducer(undefined, {}),
  submittingProfile: false,
  submittedProfile: false,
  editingProfile: false,
  containerIsValid: false,
  fetchedContactNumberTypes: false
}

const validateProfile = (state) => {
  const validationstate = validateProfileForApproval(state.pendingApprovalProfile)
  state.readyForApproval = validationstate.valid
  state.invalidArray = validationstate.invalidArr
  const { blurb, languagePreferences, investmentMinimums, conflictDeclarations, clientTypes, areasOfSpecialisation, contactDetails } = state
  state.containerIsValid = blurb.isInvalid.formIsValid &&
    investmentMinimums.isInvalid.formIsValid &&
    languagePreferences.isInvalid.formIsValid &&
    conflictDeclarations.isInvalid.formIsValid &&
    clientTypes.isInvalid.formIsValid &&
    areasOfSpecialisation.isInvalid.formIsValid &&
    contactDetails.isInvalid.formIsValid
  return state
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  if (actionTypeInCollection(action.type, rejectPendingApprovalProfileEvents)) {
    if (newState.rejectProfile.submitting) {
      newState.submittingProfile = true
      newState.submittedProfile = false
    }
    if (newState.rejectProfile.submitted) {
      newState.submittingProfile = false
      newState.submittedProfile = true
      newState.promoteToApproved.disabled = true
    }
    newState = rejectProfileReducer(newState, action)
    return newState
  }

  switch (action.type) {
    case containerEvents.reset:
      return cloneDeep(initialState)
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE:
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE:
      newState = adviserProfileWorkExperienceEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER:
    case PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS:
    case PENDING_APPROVAL_STOP_EDITING_CONTACT_NUMBERS:
    case PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS:
    case PENDING_APPROVAL_SET_CONTACT_NUMBER:
    case PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL:
    case PENDING_APPROVAL_DELETE_CONTACT_NUMBER:
    case PENDING_APPROVAL_DELETED_CONTACT_NUMBER:
    case PENDING_APPROVAL_DELETING_CONTACT_NUMBER:
    case PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER:
    case PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS:
    case PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS:
    case PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS:
    case PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS:
      newState = adviserProfileContactDetailsEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case containerEvents.fetch.fetched:
      return state.foundDifferences ? state : findProfileDifferences(cloneDeep(state), action)
    case START_EDITING_PENDING_APPROVAL_BLURB:
    case STOP_EDITING_PENDING_APPROVAL_BLURB:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_TITLE:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY_WEBSITE:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_CITY:
    case SET_PENDING_APPROVAL_BLURB_ADVISER_DESCRIPTION:
    case CANCEL_EDITING_PENDING_APPROVAL_BLURB:
      newState = adviserProfileBlurbEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case STOP_EDITING_PENDING_APPROVAL_LANGUAGES:
    case START_EDITING_PENDING_APPROVAL_LANGUAGES:
    case CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES:
    case PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES:
    case PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED:
      newState = adviserProfileLanguagePreferencesEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case PENDING_APPROVAL_START_EDITING_CLIENT_TYPES:
    case PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES:
    case PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES:
    case PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES:
    case PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED:
      newState = adviserProfileClientTypesEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION:
    case STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION:
    case CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION:
    case ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION:
    case ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED:
      newState = adviserProfileAreasOfSpecialisationEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS:
    case PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS:
    case PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM:
    case PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER:
    case PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS:
    case PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS:
      newState = adviserProfileInvestmentMinimumsEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS:
    case PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS:
    case PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS:
    case PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS:
    case PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED:
    case 'PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED':
      newState = adviserProfileConflictDeclarationsEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case picturesEvents.set.profilePicture:
    case picturesEvents.edit.profilePicture.start:
    case picturesEvents.edit.profilePicture.stop:
    case picturesEvents.edit.profilePicture.cancel:
    case picturesEvents.upload.profilePicture.uploading:
    case picturesEvents.upload.profilePicture.uploaded:
    case picturesEvents.edit.companyPicture.start:
    case picturesEvents.edit.companyPicture.stop:
    case picturesEvents.edit.companyPicture.cancel:
    case picturesEvents.set.companyPicture:
    case picturesEvents.upload.companyPicture.uploading:
    case picturesEvents.upload.companyPicture.uploaded:
      newState = adviserProfilePicturesEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case SUBMITTING_APPROVE_PROFILE:
      newState.submittingProfile = true
      newState.submittedProfile = false
      newState = adviserProfilePromoteToApprovedReducer(newState, action)
      return newState
    case SUBMITTED_APPROVE_PROFILE:
      newState.submittingProfile = false
      newState.submittedProfile = true
      newState = adviserProfilePromoteToApprovedReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION:
    case PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING:
    case PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING:
    case PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING:
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION:
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH:
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR:
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH:
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR:
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT:
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION:
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL:
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION:
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION:
    case PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION:
      newState = adviserProfileEducationEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case containerEvents.fetch.pendingApprovalProfile.fetched: {
      newState.fetchingPendingApprovalProfile = false
      newState.loading = newState.fetchingPublishedProfile || newState.fetchingPendingApprovalProfile
      newState.pendingApprovalProfile = action.payload
      // Validate the fetched profile up front so the Approve button can be gated on
      // completeness (and the missing-field list shown) before an admin can approve.
      const validationstate = validateProfileForApproval(action.payload)
      newState.readyForApproval = validationstate.valid
      newState.invalidArray = validationstate.invalidArr
      return newState
    }
    case containerEvents.fetch.pendingApprovalProfile.fetching:
      newState.fetchingPendingApprovalProfile = true
      newState.loading = true
      return newState
    case containerEvents.fetch.publishedProfile.fetched:
      newState.foundDifferences = false
      newState.fetchingPublishedProfile = false
      newState.loading = newState.fetchingPublishedProfile || newState.fetchingPendingApprovalProfile
      newState.publishedProfile = action.payload
      return newState
    case containerEvents.fetch.publishedProfile.fetching:
      newState.promoteToApproved = adviserProfilePromoteToApprovedReducer(undefined, {})
      newState.fetchingPublishedProfile = true
      newState.loading = true
      return newState
    case containerEvents.edit.start:
      newState.editingProfile = true
      newState.submittingProfile = false
      newState.submittedProfile = false
      newState.pendingApprovalProfileBeforeEditing = cloneDeep(newState.pendingApprovalProfile)
      return newState
    case containerEvents.edit.stop:
      newState.editingProfile = false
      newState.edited = false
      newState.actionTypeInCollectioncontainerIsValid = false
      return newState
    case containerEvents.edit.cancel:
      newState.editingProfile = false
      newState.edited = false
      newState.pendingApprovalProfile = cloneDeep(newState.pendingApprovalProfileBeforeEditing)
      newState = adviserProfileContactDetailsEditorReducer(newState, action)
      newState = adviserProfileEducationEditorReducer(newState, action)
      newState = adviserProfileWorkExperienceEditorReducer(newState, action)
      // Re-validate against the restored profile so readyForApproval/invalidArray (and the
      // Approve button state) reflect the cancelled edit instead of staying stale.
      newState = validateProfile(newState)
      return newState
    case containerEvents.submit.submitting:
      newState.submittingProfile = true
      newState.editingProfile = false
      return newState
    case containerEvents.submit.submitted:
      newState.submittingProfile = false
      newState.submittedProfile = true
      return newState
    case containerEvents.fetch.contactNumberTypes:
      newState.allContactNumberTypes = action.payload
      newState.fetchedContactNumberTypes = true
      return newState
    default:
      return state
  }
}

function findProfileDifferences (state, action) {
  // relay this event to all profiles so that they can compute profile differences
  // newState = adviserProfileBlurbEditorReducer(newState, action)
  // newState = adviserProfileInvestmentMinimumsEditorReducer(newState, action)
  state = adviserProfileConflictDeclarationsEditorReducer(state, action)
  state = adviserProfileClientTypesEditorReducer(state, action)
  state = adviserProfileAreasOfSpecialisationEditorReducer(state, action)
  state = adviserProfileLanguagePreferencesEditorReducer(state, action)
  state = adviserProfileContactDetailsEditorReducer(state, action)
  state = adviserProfileEducationEditorReducer(state, action)
  state = adviserProfileWorkExperienceEditorReducer(state, action)
  // newState = adviserProfilePicturesEditorReducer(newState, action)
  // newState = AdviserProfilePromoteToApprovedReducer(newState, action)
  state.foundDifferences = true
  return state
}
